// URLのハッシュに基づいて初期タブを設定
window.addEventListener('load', () => {
    if (window.location.hash === '#story2') {
        document.getElementById('tab2').checked = true;
    }
});

// タブ切り替え時にURLハッシュを更新
document.querySelectorAll('.rt-tabs__radio').forEach(radio => {
    radio.addEventListener('change', (e) => {
        const hash = e.target.id === 'tab1' ? '#story1' : '#story2';
        history.replaceState(null, '', hash);
    });
});